// @flow

import React from 'react';
import { observer } from 'mobx-react';
import FontAwesome from 'react-fontawesome';
import { css } from 'glamor';

const rule = css({
    color: '#fff',
    ':hover': {
        color: 'rgb(228, 65, 34)',
    },
});

const marginRule = css({
    marginLeft: '30px',
});

@observer
export default class SocialBar extends React.Component {
    render() {
        return (
            <div>
                <a { ...rule } href="https://www.facebook.com/supagemu">
                    <FontAwesome name="facebook" size="2x" />
                </a>
                <a
                    { ...rule }
                    { ...marginRule }
                    href="https://twitter.com/supagemu"
                >
                    <FontAwesome name="twitter" size="2x" />
                </a>
                <a
                    { ...rule }
                    { ...marginRule }
                    href="https://www.upglober.com/group_profile.php?group_id=87"
                >
                    <FontAwesome name="globe" size="2x" />
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/SocialBar/index.js